import { render } from "./MonthlyBatchProductionCosts.vue?vue&type=template&id=9e4a46c0&scoped=true"
const script = {}

import "./MonthlyBatchProductionCosts.vue?vue&type=style&index=0&id=9e4a46c0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e4a46c0"]])

export default __exports__